import React, { useEffect, useState, useRef } from "react";
import { Box, Paper, Fade, CircularProgress } from "@mui/material";
import QRCodeStyling, { DrawType, ErrorCorrectionLevel, Options, TypeNumber, Mode, DotType, CornerDotType } from "qr-code-styling";

interface QRCodeDisplayProps {
  identifier: string;
  fgColor?: string;
  bgColor?: string;
  iconURL?: string;
  width?: number;
  height?: number;
}

const QRCodeDisplay: React.FC<QRCodeDisplayProps> = ({ identifier, fgColor = "#0C2340", bgColor = "#ffffff", iconURL = "/skidattl-icon.png", width = 256, height = 256 }) => {

  const qrRef = useRef<QRCodeStyling | null>(null);
  const canvasRef = useRef<HTMLDivElement>(null);
  const [isLoading, setIsLoading] = useState(false);

  const qrWidth = 1024;
  const qrHeight = 1024;

	useEffect(() => {
		const options: Options = {
			width: qrWidth,
			height: qrHeight,
			type: "canvas" as DrawType,
			data: `https://ar.skidattl.com/i/${identifier}`,
			image: iconURL,
			qrOptions: {
			typeNumber: 0 as TypeNumber,
			mode: "Byte" as Mode,
			errorCorrectionLevel: "Q" as ErrorCorrectionLevel,
			},
			imageOptions: {
			hideBackgroundDots: true,
			imageSize: 0.5,
			margin: 30,
			crossOrigin: undefined,
			},
			dotsOptions: {
			color: fgColor,
			type: "square" as DotType,
			},
			backgroundOptions: {
			color: bgColor,
			},
			cornersSquareOptions: {
			color: fgColor,
			type: "square" as CornerDotType,
			},
			cornersDotOptions: {
			color: fgColor,
			type: "square" as CornerDotType,
			},
		};

		qrRef.current = new QRCodeStyling(options);

		if (canvasRef.current) {
			qrRef.current.append(canvasRef.current);
			qrRef.current._getElement().then((canvas) => {
			if (canvas) {
				canvas.style.width = "100%";
				setIsLoading(false);
			}
			});
		}

		return () => {
			if (canvasRef.current) {
			canvasRef.current.innerHTML = "";
			}
		};
	}, [identifier, fgColor, bgColor, iconURL]);

  return (
	<Paper
		sx={{
		backgroundColor: "#ffffff",
		borderRadius: "4px",
		width: width + width * 0.2,
		height: height + height * 0.2,
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		position: "relative",
		}}
	>
		<Fade in={!isLoading} timeout={700}>
		<Box
			ref={canvasRef}
			sx={{ display: isLoading ? "none" : "block", width: width, height: height }}
		/>
		</Fade>
		{isLoading && (
		<Box
			sx={{
			position: "absolute",
			top: "50%",
			left: "50%",
			transform: "translate(-50%, -50%)",
			}}
		>
			<CircularProgress />
		</Box>
		)}
	</Paper>
  );
};

export default QRCodeDisplay;
